export default {
  set_pageCatalogShopId(state, value) {
    state.pageCatalogShopId = value;
  }
};
